import React, { useState } from 'react';
import ErrorWrapper from '@/app/ErrorWrapper';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid'; 
import viLocale from '@fullcalendar/core/locales/vi';
import enGbLocale from '@fullcalendar/core/locales/en-gb';

const locales = {
  en: enGbLocale,
  vi: viLocale,
};

const FullCalendarComponent = ({ events = [], onEventClick, currentLocale }) => {
    return (
        <div id="calendar">
            <FullCalendar
                eventClassNames={'text-white'}
                plugins={[dayGridPlugin]}
                dayNumbers={true}
                initialView="dayGridMonth"
                events={events}
                eventClick={onEventClick}
                headerToolbar={{
                    left: 'prev,next today',
                    center: 'title',
                    right: 'dayGridMonth,dayGridWeek,dayGridDay'
                }}
                editable={true}
                selectable={true}
                locale={locales[currentLocale]} 
            />
        </div>
    );
};

FullCalendarComponent.displayName = 'FullCalendar';

const FullCalendarCpn = (props) => {
    return (
        <ErrorWrapper>
            <FullCalendarComponent data-id='FullCalendar-cpn' {...props} />
        </ErrorWrapper>
    );
};

export default FullCalendarCpn;